// Small UX helpers (no framework)

// Smooth scroll for anchor links
for (const a of document.querySelectorAll('a[href^="#"]')) {
  a.addEventListener('click', (e) => {
    const id = a.getAttribute('href');
    const el = id ? document.querySelector(id) : null;
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });

    // Close mobile nav on click
    const nav = document.querySelector('.nav');
    const toggle = document.querySelector('.nav-toggle');
    if (nav && toggle) {
      nav.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
    }
  });
}

// Mobile nav toggle
const navToggle = document.querySelector('.nav-toggle');
const navMenu = document.querySelector('.nav');
if (navToggle && navMenu) {
  navToggle.addEventListener('click', () => {
    const isOpen = navMenu.classList.toggle('open');
    navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
}

// Reveal animations
const io = new IntersectionObserver(
  (entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) e.target.classList.add('in');
    });
  },
  { threshold: 0.08 }
);

document.querySelectorAll('.reveal').forEach((el) => io.observe(el));

// Vergangene Termine dynamisch markieren
const today = new Date();
today.setHours(0, 0, 0, 0);

document.querySelectorAll('.termine-card').forEach((card) => {
  const year = parseInt(card.querySelector('.termine-jahr')?.textContent.trim(), 10);
  if (!year) return;
  card.querySelectorAll('li').forEach((li) => {
    const datumEl = li.querySelector('.termin-datum');
    if (!datumEl) return;
    const parts = datumEl.textContent.trim().split('.');
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const date = new Date(year, month, day);
    if (date < today) {
      li.classList.add('termin-past');
    }
  });
});
